import { EditOutlined } from '@ant-design/icons';

export const appointmentStatus = {
  absence: {
    value: 'Inasistencia',
    alias: 'absence',
    color: '8D8D8D',
  },
  finished: {
    value: 'Terminada',
    alias: 'finished',
    color: '319799',
  },
  inProcess: {
    value: 'En Proceso',
    alias: 'inProcess',
    color: 'EE734E',
  },
  scheduled: {
    value: 'Agendada',
    alias: 'scheduled',
    color: '7557D4',
  },
  cancelled: {
    value: 'Cancelada',
    alias: 'cancelled',
    color: 'FF0000',
  },
  edited: {
    value: 'Editada',
    alias: 'edited',
    color: 'FFA500',
  },
};

export const appointmentStatusCalendar = {
  absence: {
    value: 'Inasistencia',
    alias: 'absence',
    color: '8D8D8D',
  },
  finished: {
    value: 'Terminada',
    alias: 'finished',
    color: '319799',
  },
  inProcess: {
    value: 'En Proceso',
    alias: 'inProcess',
    color: 'EE734E',
  },
  scheduled: {
    value: 'Agendada',
    alias: 'scheduled',
    color: '7557D4',
  },
};

export const appointmentStatusConst = [
  { value: appointmentStatus.absence.alias, label: 'Inasistencia' },
  { value: appointmentStatus.finished.alias, label: 'Terminada' },
  { value: appointmentStatus.inProcess.alias, label: 'En proceso' },
  { value: appointmentStatus.scheduled.alias, label: 'Agendada' },
];

export const appointmentConst = {
  DOCTOR: 'Médico',
  COSMETOLOGIST: 'Cosmetóloga',
  VALUATION: 'Valoración',
  REDEMPTION_BRANCH: {
    AUTHORIZATION_REQUIRED: 'REDEMPTION_BRANCH_AUTHORIZATION_REQUIRED',
    TITLE: 'Autorización para cambio de sucursal',
    CODE_LABEL: 'Código de autorización',
    REASON_LABEL: 'Motivo del cambio',
  },
  TOOLTIPS: {
    CUSTOMER_HISTORY: 'Ver historial del cliente',
    EDIT_APPOINTMENT: 'Editar cita',
    EDIT_OBSERVATIONS: 'Editar observaciones',
    CHANGE_STATUS: 'Cambiar estado de cita',
    CANCEL_APPOINTMENT: 'Cancelar cita',
  },
  BLACKLIST_ALERT_TYPE: 'blackList',
  IS_ADULT_ALERT_TYPE: 'isAdult',
  MISSED_APPOINTMENTS_ALERT_TYPE: 'missedAppointments',
  NOTES_ALERT_TYPE: 'notes',
  EDIT_WITHIN_24H_ALERT_TYPE: 'editWithin24h',
  NOTES: 'Notas',
  ADD_PATIENT: 'Agregar paciente',
  MISSED_APPOINTMENTS_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION:
      'Este tratamiento ha sido reagendado 2 veces y ya no puede puede modificarse',
    OK_BUTTON: 'Entendido',
  },
  CANCEL_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION:
      'Esta sera la tercera cancelacion o cambio para este tratamiento, al continuar se dara por terminado',
  },
  PURCHASED_PRODUCT_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION: 'Tratamiento no pagado',
  },
  BLACKLIST_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION:
      'El cliente se encuentra en lista negra, para continuar debes ir a la sección de clientes y retirarlo de la lista',
    OK_BUTTON: 'Editar cliente',
    CANCEL_BUTTON: 'Volver a la agenda',
  },
  NOTES_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION:
      'Este cliente tiene notas importantes, para verlas da click en ver notas',
    OK_BUTTON: 'Ver notas',
    CANCEL_BUTTON: 'Continuar',
  },
  ADULT_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION:
      'Este cliente ya tiene la mayoría de edad y debe de asignar un número de télefono',
    OK_BUTTON: 'Editar cliente',
    CANCEL_BUTTON: 'Continuar',
  },
  EDIT_WITHIN_24H_ALERT: {
    TITLE: 'ATENCIÓN',
    DESCRIPTION: '¿Es el cliente él que desea modificar la cita?',
    OK_BUTTON: 'Si',
    CANCEL_BUTTON: 'No',
  },
};

export const confirmMethodsConst = [
  { value: 'si', label: 'Si' },
  { value: 'no', label: 'No' },
  { value: 'whatsapp', label: 'Whatsapp' },
  { value: 'buzón', label: 'Buzón' },
  { value: 'email', label: 'Correo' },
  { value: 'app', label: 'App' },
  { value: 'ecommerce', label: 'Ecommerce' },
];

export const cancellationReasonConst = [
  { value: 'Traffic', label: 'Tráfico' },
  { value: 'Desease', label: 'Enfermedad' },
  { value: 'Work', label: 'Trabajo' },
  { value: 'Unspecified', label: 'Sin especificar' },
  { value: 'Other', label: 'Otro' },
];

export const searchInputInitialValues = {
  search: { filter: 'appointment_number' },
};

export const searchFilters = [
  { value: 'appointment_number', label: 'Cita' },
  { value: 'attendedBy.name', label: 'Atendió' },
  { value: 'customer.name', label: 'Cliente' },
  { value: 'treatment.name', label: 'Tratamiento' },
  { value: 'user.name', label: 'Agendo' },
];

export const filters = {
  appointmentStatus: true,
  search: true,
  date: true,
  branches: true,
  dates: true,
  multipleCabains: true,
};

export const missedAppointmentConst = {
  TYPES: {
    CANCELLATION: 'Cancellation',
    RESCHEDULE: 'Reschedule',
    EDITED: 'Edited',
  },
  REASON_DICTIONARY: {
    Traffic: 'Tráfico',
    Desease: 'Enfermedad',
    Work: 'Trabajo',
    Unspecified: 'Sin especificar',
    Other: 'Otro',
  },
};

export const optionDictionary = {
  promotions: 'Promociones',
  packages: 'Paquetes',
  purchasedProducts: 'Tratamientos adquiridos',
  newTreatments: 'Nuevos tratamientos',
};

export const appointmentsTableMenuOpt = [
  {
    label: 'Médico',
    key: 'edit',
    icon: <EditOutlined />,
    privilege: 'edit',
  },
];
